import Vue from "vue";

export function pageAllProductApi(params, success, complete) {
    let url = "/admin/web/product/pageAllProduct";
    Vue.prototype.alexPost(url, params, success, null, complete);
}

export function pageMerchantProductApi(params, success, complete) {
    let url = "/admin/web/product/pageMerchantProduct";
    Vue.prototype.alexPost(url, params, success, null, complete);
}

export function deleteProductApi(params, success) {
    let url = "/admin/web/product/deleteProduct";
    Vue.prototype.alexPost(url, params, success);
}

export function updateIsShelfApi(params, success) {
    let url = "/admin/web/product/updateIsShelf";
    Vue.prototype.alexPost(url, params, success);
}


export function updateIsShowIndexApi(params, success) {
    let url = "/admin/web/product/updateIsShowIndex";
    Vue.prototype.alexPost(url, params, success);
}

export function countAllProductApi(params, success) {
    let url = "/admin/web/product/countAllProduct";
    Vue.prototype.alexPost(url, params, success);
}





